export default "__VITE_ASSET__D3cjCzD$__"